import service from '@/utils/server';
let model = '/fm/fmPermission/';
export const queryList = data => {
    return service({
        url: model+'pageInfo',
        method: 'post',
        data
    })
};

//
export const getAddPermission = data => {
  return service({
    url: model+'add',
    method: 'post',
    data
  })
};

//
export const getUpdatePermission = data => {
  return service({
    url: model+'update',
    method: 'post',
    data
  })
};
export const getDeletePermissionList = data => {
  return service({
    url: model+'delete/'+data.permissionId,
    method: 'post'
  })
};

//
export const getAllPageOpList = data => {
  return service({
    url: model+'getAllPageOpList',
    method: 'post',
    data
  })
};

//
export const getResetPageOp = data => {
  return service({
    url: model+'resetPageOp',
    method: 'post',
    data
  })
};

export const getMenuByClientId = data => {
  return service({
    url: model+'getMenuByClientId/'+data.clientId,
    method: 'post'
  })
};



// WEBPACK FOOTER //
// ./src/page/auth/permission/api/index.js